import { useState } from "react";
import { NavLink } from "react-router-dom";
import { IonRow, IonCol } from "@ionic/react";
import { Loading, SEO, PageTitle } from "../components";

export const Merch = (props) => {
  const { isMobile, config } = props;

  const [loading, setLoading] = useState(true);
  const seo = config?.SEO.merch;

  return (
    <div id="MerchPage" className="merch-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
      />
      {loading && <Loading />}
      <div className="merch-box">
        <IonRow>
          <IonCol size={isMobile ? "12" : "5"} className="flex-center">
            <iframe
              className="merch-frame"
              title="title"
              src="https://bandcamp.com/EmbeddedPlayer/album=2312353811/size=large/bgcol=333333/linkcol=0f91ff/minimal=true/transparent=true/"
              seamless
              loading="lazy"
              decoding="async"
              fetchpriority="high"
              onLoad={() => setLoading(false)}
            />
          </IonCol>
          <IonCol size={isMobile ? "12" : "7"} className="flex-center-column">
            <PageTitle
              pageTitle={
                <>
                  SUCCULENT ALBUM CD PACK <span className="number">432</span>
                  Hz
                </>
              }
            />
            <img
              src="/assets/Suculent-Album-432Hz-CD-PACK_Hardcore-Buddhist.webp"
              alt="Suculent-Album-432Hz-CD-PACK_Hardcore-Buddhist"
              loading="eager"
              decoding="async"
              fetchpriority="high"
              draggable="false"
              onLoad={() => setLoading(false)}
            />
            <p>
              Includes unlimited streaming of Succulent album via the free
              Bandcamp app, plus high-quality download in MP3, FLAC and more!
            </p>
            <NavLink
              to="https://hardcorebuddhist.bandcamp.com/album/hardcore-buddhist-succulent-432hz-cd-only"
              target="_blank"
              className="flashing-btn"
              rel="noopener"
            >
              <div className="link-text-home">
                €<span className="number">15.00</span>
              </div>
            </NavLink>
            &nbsp;
          </IonCol>
        </IonRow>
      </div>
    </div>
  );
};
